var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-button"},[_c('div',{staticClass:"x",on:{"click":function($event){return _vm.close()}}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }